import React, { useEffect, useState } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { BsSquare } from "react-icons/bs";
import { FaMousePointer } from "react-icons/fa";
import { HiPencil } from "react-icons/hi";
import { GrAd } from "react-icons/gr";
import { IoMdUndo } from "react-icons/io";
import { IoIosTrash } from "react-icons/io";
import { TbArrowDownBar } from "react-icons/tb";
import { TbArrowLeftBar } from "react-icons/tb";
import useActiveObjectId from "../store/useActiveObjectId";
import useUserMode from "../store/useUserMode";
import $ from "jquery";
import { IconPlusSquare } from "../../icons/icons";

const ToolTip = ({ setting, setSetting, drawingCanva }) => {
  const setActiveObjectId = useActiveObjectId(
    (state) => state.setActiveObjectId
  );
  const userMode = useUserMode((state) => state.userMode);
  const setUserMode = useUserMode((state) => state.setUserMode);
  const [visibleSubitem, setVisibleSubitem] = useState(null);
  const [activeSuperitem, setActiveSuperitem] = useState(null);
  const [indicatorChange, setIndicatorChange] = useState([]);

  const userModeButtons = [
    {
      mode: "line",
      label: "line",
      icon: <HiPencil />,
      subitems: [
        {
          mode: "trendline",
          label: "Trendline",
          action: () => {
            setUserMode("line");
            setVisibleSubitem(null);
          },
          icon: <HiPencil />,
        },
        {
          mode: "duplicateTrendline",
          label: "Duplicate Trendline",
          action: () => {
            window.dispatchEvent(new CustomEvent("duplicateTrendline"));
             setUserMode("select");
            setVisibleSubitem(null);
          },
          icon: IconPlusSquare,
        },
        {
          mode: "vertical",
          label: "Vertical Line",
          action: () => {
            setUserMode("vertical");
            setVisibleSubitem(null);
          },
          icon: <TbArrowDownBar />,
        },
        {
          mode: "horizontal",
          label: "Horizontal Line",
          action: () => {
            setUserMode("horizontal");
            setVisibleSubitem(null);
          },
          icon: <TbArrowLeftBar />,
        },
      ],
    },
    // {
    //   mode: 'callout',
    //   label: 'callout',
    //   icon: <BsSquare
    //   />,
    // },
    // {
    //   mode: 'fibonacci',
    //   label: 'fibonacci',
    //   icon: <GrAd
    //   />,
    // },
    {
      mode: "undo",
      label: "undo",
      icon: <IoMdUndo />,
    },

    {
      mode: "clear",
      label: "clear",
      icon: <IoIosTrash />,
    },
  ];


  useEffect(() => {
    const resetSelection = (event) => {
      // console.log(event.detail.resetSelection , "eventssssssssssss")
      handleButtonClick("select");
    };

    window.addEventListener("resetSelection", resetSelection);
  }, [window.addEventListener]);

  useEffect(() => {
    updatePosition()
    document.addEventListener('indicatorChangeEvent', (event) => {
      updatePosition();
    });
  }, [indicatorChange]); // Depend on indicatorConfig

  const updatePosition = () => {
    const toolbar = $("#button-container-wrapper");
    let totalHeight = 0;

    $('.chart-item').each(function() { // true includes margin
      if ($(this).hasClass('chart-main')) {
        return false; // Exit the loop
      }
      totalHeight += $(this).outerHeight(true);
    });

    toolbar.css('top', 70 + totalHeight)
  }

  const handleButtonClick = (mode, subitems) => {
    if (userMode === mode) {
      setUserMode(null);
      setTimeout(() => {
        setUserMode(mode);
      }, 0);
    } else {
      setUserMode(mode);
    }
    setActiveObjectId(null);
    setActiveSuperitem(mode); // Add this line
    if (subitems) {
      setVisibleSubitem(visibleSubitem === mode ? null : mode);
    } else setVisibleSubitem(null);
  };

  const renderSubitems = (mode) => {
    const button = userModeButtons.find((button) => button.mode === mode);
    if (!button || !button.subitems) {
      return null;
    }

    return (
      <div className="subitem-dropdown">
        {button.subitems.map((subitem, index) => (
          <div
            key={index}
            className="subitem"
            onClick={() => {
              subitem.action();
              setActiveSuperitem(mode); // Add this line
            }}
          >
            {subitem.icon && (
              <span className="subitem-icon">{subitem.icon}</span>
            )}
            <span>{subitem.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const renderUserModeButtons = (buttons) => (
    <div className="button-container">
      {buttons.map(({ mode, label, icon, subitems }) => {
        const isActive = userMode === mode || activeSuperitem === mode;
        return (
          <div key={mode} className="relative">
            <Tooltip
              label={label + (isActive ? " (active)" : "")}
              position="right"
              withArrow
              transition="slide-left"
              transitionDuration={200}
            >
              <ActionIcon
                color="danger"
                variant={isActive ? "outline" : "light"}
                size="lg"
                onClick={() => handleButtonClick(mode, subitems)}
              >
                {icon}
              </ActionIcon>
            </Tooltip>
            {visibleSubitem === mode && renderSubitems(mode)}
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      className="overlay-navbar ml-3"
      id="button-container-wrapper"
      // Keep the drawing toolbar (and its open Trendline sub-menu) out of the
      // shared-chart screenshot — html2canvas skips any element flagged with
      // this attribute, so a chart posted with the tool open shows only the
      // drawn lines, not the editing chrome.
      data-html2canvas-ignore="true"
      style={{ zIndex: 30 }}
    >
      {renderUserModeButtons(userModeButtons)}
    </div>
  );
};

export default ToolTip;
